import { render, staticRenderFns } from "./RootsAndDegrees.vue?vue&type=template&id=22838e28&scoped=true&lang=pug&"
import script from "./RootsAndDegrees.vue?vue&type=script&lang=js&"
export * from "./RootsAndDegrees.vue?vue&type=script&lang=js&"
import style0 from "./RootsAndDegrees.vue?vue&type=style&index=0&id=22838e28&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22838e28",
  null
  
)

export default component.exports